import { useQueryClient } from '@tanstack/react-query';

import { useCableSubscription } from './use-cable-subscription';

export function useSyncsSubscription() {
  const client = useQueryClient();

  const reloadSyncs = () => client.invalidateQueries({ queryKey: ['syncs'] });

  useCableSubscription('SyncsChannel', { connected: reloadSyncs, received: reloadSyncs });
}
